import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FilterBoxComponent } from './filter-box/filter-box.component';
import { FilterMapComponent } from './filter-map/filter-map.component';
import { FilterSelectionComponent } from './filter-selection/filter-selection.component';
import { MainViewComponent } from './main-view/main-view.component';
import { ResultBoxComponent } from './result-box/result-box.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { SelectedFilterPipe } from './filter-selection/selected-filter.pipe';

@NgModule({
  declarations: [
    AppComponent,
    MainViewComponent,
    FilterBoxComponent,
    FilterSelectionComponent,
    MainViewComponent,
    ResultBoxComponent,
    FilterMapComponent,
    DropdownComponent,
    SelectedFilterPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts